module.exports = __webpack_public_path__ + "media/images/site/biblioteca-1922770d776b0bfeb3e219cc3bbc2d91.jpg";